import {
  pluginLinkButtonViewer,
  pluginActionButtonViewer,
  pluginCodeBlockViewer,
  pluginDividerViewer,
  pluginEmojiViewer,
  pluginFileUploadViewer,
  pluginGalleryViewer,
  pluginGiphyViewer,
  pluginHashtagViewer,
  pluginHtmlViewer,
  pluginImageViewer,
  pluginLineSpacingViewer,
  pluginLinkViewer,
  pluginLinkPreviewViewer,
  pluginPollViewer,
  pluginSpoilerViewer,
  pluginCollapsibleListViewer,
  pluginMentionsViewer,
  pluginVerticalEmbedViewer,
  pluginVideoViewer,
  pluginTocViewer,
  pluginAudioViewer,
  pluginTableViewer,
  pluginTextColorViewer,
  pluginTextHighlightViewer,
} from '@wix/ricos';
import '@wix/ricos/css/plugin-button-viewer.global.css';
import '@wix/ricos/css/plugin-divider-viewer.global.css';
import '@wix/ricos/css/plugin-file-upload-viewer.global.css';
import '@wix/ricos/css/plugin-gallery-viewer.global.css';
import '@wix/ricos/css/plugin-giphy-viewer.global.css';
import '@wix/ricos/css/plugin-hashtag-viewer.global.css';
import '@wix/ricos/css/plugin-html-viewer.global.css';
import '@wix/ricos/css/plugin-image-viewer.global.css';
import '@wix/ricos/css/plugin-link-viewer.global.css';
import '@wix/ricos/css/plugin-link-preview-viewer.global.css';
import '@wix/ricos/css/plugin-social-polls-viewer.global.css';
import '@wix/ricos/css/plugin-spoiler-viewer.global.css';
import '@wix/ricos/css/plugin-collapsible-list-viewer.global.css';
import '@wix/ricos/css/plugin-mentions-viewer.global.css';
import '@wix/ricos/css/plugin-vertical-embed-viewer.global.css';
import '@wix/ricos/css/plugin-video-viewer.global.css';
import '@wix/ricos/css/plugin-audio-viewer.global.css';
import '@wix/ricos/css/plugin-table-viewer.global.css';
import '@wix/ricos/css/plugin-toc-viewer.global.css';
// import { verticalEmbedProviders } from 'wix-rich-content-plugin-vertical-embed';
import { getSelectedPluginsFromSettings } from './plugin-settings';

// const { event, booking, product } = verticalEmbedProviders;

const defaultConfigs = {
  socialPlugin: { enableEmbed: true },
};

const defaultPlugins = {
  HashtagPlugin: () => pluginHashtagViewer(),
  LineSpacingPlugin: () => pluginLineSpacingViewer(),
  LinkPlugin: (config: any) => pluginLinkViewer(config),
  MentionsPlugin: () => pluginMentionsViewer(),
};
const selectablePlugins: Record<string, any> = {
  PluginToc: () => pluginTocViewer(),
  ImagePlugin: () => pluginImageViewer(),
  VideoPlugin: () => pluginVideoViewer(),
  AudioPlugin: () => pluginAudioViewer(),
  GalleryPlugin: () => pluginGalleryViewer(),
  FilePlugin: () => pluginFileUploadViewer(),
  DividerPlugin: () => pluginDividerViewer(),
  ButtonPlugin: () => pluginLinkButtonViewer(),
  GifPlugin: () => pluginGiphyViewer(),
  CodeBlockPlugin: () => pluginCodeBlockViewer(),
  EmojiPlugin: () => pluginEmojiViewer(),
  EmbedPlugin: () => pluginHtmlViewer(),
  TextColorPlugin: () => pluginTextColorViewer(),
  TextHighlightColorPlugin: () => pluginTextHighlightViewer(),
  CollapsibleListPlugin: () => pluginCollapsibleListViewer(),
  TablePlugin: () => pluginTableViewer(),

  // social
  SocialPlugin: () => pluginLinkPreviewViewer(defaultConfigs.socialPlugin),
  PollPlugin: () => pluginPollViewer(),

  // experimental
  VerticalEmbed: (config: any = {}) => pluginVerticalEmbedViewer(config),
  ActionButtonPlugin: () => pluginActionButtonViewer(),
  SpoilerPlugin: () => pluginSpoilerViewer(),
};

export const getSelectedPlugins = (
  selectedPlugins: Record<string, boolean>,
  additionalSettings: Record<string, any>,
) => {
  return getSelectedPluginsFromSettings(
    selectedPlugins,
    defaultPlugins,
    selectablePlugins,
    additionalSettings,
  );
};
